import React from 'react';
import {Link} from "react-router-dom";

const Category = (props) => {
    return props.category.categories.length === 0 ?
        <div className="col-all-2" key="view_all">
            <div className="wrapper--item delay--13 view--entry h-100" data-aos="fade-up">
                <Link to={`${process.env.PUBLIC_URL}/category/allday/view-all/`}>
                    <div className="bdr--grad h-200-md index-sm-100h">
                        <div className="proceed-logs">
                            <img src={`${process.env.PUBLIC_URL}/image/view_all.png`} alt="silverbackdeals" />
                            <span>View All</span>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
        :
        <div className="col-all-2">
            <div className="wrapper--item delay--1" data-aos="fade-up">
                <div onClick={props.clickHandler}>
                    <div className="bdr--grad">
                        <div className="proceed-logs">
                            <img src={props.category.image} alt={props.category.name}/>
                        </div>
                    </div>
                </div>
                <div className="dealsbox-info"><span>{props.category.name}</span></div>
            </div>
        </div>
        ;
}

export default Category;